import loginTemplate from 'components/login/login.html';
import signupTemplate from 'components/signup/signup.html';
import inactiveTemplate from 'components/inactive/inactive.html';
import fourOhFourTemplate from 'components/404/404.html';
import appTemplate from 'components/app/app.html';
import salesTemplate from 'components/sales/sales.html';
import trackingTemplate from 'components/tracking/tracking.html';
import membershipTemplate from 'components/membership/membership.html';
import developersTemplate from 'components/developers/developers.html';
import settingsTemplate from 'components/settings/settings.html';
import stripeConnectSuccessTemplate from 'components/stripeConnectSuccess/stripeConnectSuccess.html';

function configureRoutes($stateProvider) {
  $stateProvider
    .state('login', {
      url: '/login?redirectState&redirectParams',
      template: loginTemplate,
      controller: 'loginCtrl'
    })
    .state('signup', {
      url: '/signup',
      template: signupTemplate,
      controller: 'signupCtrl'
    })
    .state('inactive', {
      url: '/inactive',
      template: inactiveTemplate,
      controller: 'inactiveCtrl'
    })
    .state('404', {
      url: '/404',
      template: fourOhFourTemplate,
      controller: '404Ctrl'
    })
    .state('app', {
      url: '/',
      template: appTemplate,
      controller: 'appCtrl',
      authenticate: true,
      resolve: {
        currentUser: [
          'jsSdk.user',
          'jsSdk.auth',
          '$q',
          (userService, authService, $q) => {
            if (!authService.isLoggedIn()) {
              return $q.resolve(null);
            }

            return userService.me();
          }
        ],
        affiliate: [
          '$rootScope',
          '$state',
          '$timeout',
          'tl.user.service',
          'currentUser',
          ($rootScope, $state, $timeout, userService, currentUser) => {
            return userService.listAffiliates({
                userId: currentUser._id
              })
              .then(affiliates => {
                return affiliates && affiliates.length ? affiliates[0] : null;
              });
          }
        ]
      }
    })
    .state('app.stripeConnectSuccess', {
      url: 'stripe-connect?stripe_user_id&error&error_description',
      template: stripeConnectSuccessTemplate,
      controller: 'stripeConnectSuccessCtrl',
      authenticate: true
    })
    .state('app.sales', {
      url: 'sales?start&end&trackingId',
      template: salesTemplate,
      controller: 'salesCtrl',
      authenticate: true,
      reloadOnSearch: false
    })
    .state('app.tracking', {
      url: 'tracking',
      template: trackingTemplate,
      controller: 'trackingCtrl',
      authenticate: true
    })
    .state('app.membership', {
      url: 'membership?start&end&trackingId',
      template: membershipTemplate,
      controller: 'membershipCtrl',
      authenticate: true
    })
    .state('app.developers', {
      url: 'developers',
      template: developersTemplate,
      controller: 'developersCtrl',
      authenticate: true
    })
    .state('app.settings', {
      url: 'settings?stripeUserId',
      template: settingsTemplate,
      controller: 'settingsCtrl',
      authenticate: true
    });
}

function RouterConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  if (window.history && window.history.pushState) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
  }

  $urlRouterProvider.when('', '/');

  $urlRouterProvider.otherwise(($injector, $location) => {
    let path = '/404';

    if ($location && $location.$$absUrl) {
      path += `?target=${$location.$$absUrl}`;
    }

    return path;
  });

  configureRoutes($stateProvider);

  //REDIRECTS
}

RouterConfig.$inject = [
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider'
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/routerConfig.js